import type { AgentApiCandidateFormsShow } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

export default function useFetchCandidateForm() {
  return useQuery({
    queryKey: ['candidate_forms'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_forms.json');

      if (!response.ok) {
        if (response.status === 404) {
          // 404の場合はnullを返す（フォーム未作成）
          // エラーとして扱わないようにするため、nullを返す
          return null;
        }
        // その他のエラーは例外として投げる
        throw new Error(`Failed to fetch candidate form: ${response.status}`);
      }

      const data: AgentApiCandidateFormsShow = await response.json();
      return data;
    },
  });
}
